import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=deb65ed6&scoped=true&"
import script from "./Dashboard.js?vue&type=script&lang=js&"
export * from "./Dashboard.js?vue&type=script&lang=js&"
import style0 from "./Dashboard.css?vue&type=style&index=0&id=deb65ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb65ed6",
  null
  
)

export default component.exports